import { Building2, User } from 'lucide-react'

import { Label } from '@/components'
import { cn } from '@/utils'

export const ACCOUNT_TYPES = {
  firm: 'firm',
  individual: 'individual',
} as const

export type AccountType = (typeof ACCOUNT_TYPES)[keyof typeof ACCOUNT_TYPES]

const OPTIONS = [
  { value: ACCOUNT_TYPES.firm, label: 'A firm', icon: Building2 },
  { value: ACCOUNT_TYPES.individual, label: 'An individual', icon: User },
]

interface AccountTypeToggleProps {
  value?: string
  setFieldValue: (name: string, value?: string) => void
}

export const AccountTypeToggle = ({
  value,
  setFieldValue,
}: AccountTypeToggleProps) => (
  <div className="space-y-1.5">
    <Label>Are you a firm or an individual?</Label>
    <div className="grid grid-cols-2 gap-2">
      {OPTIONS.map(({ value: option, label, icon: Icon }) => {
        const selected = value === option
        return (
          <button
            key={option}
            type="button"
            aria-pressed={selected}
            onClick={() => setFieldValue('accountType', option)}
            className={cn(
              'flex items-center justify-center gap-2 rounded-md border px-3 py-2 text-sm font-medium cursor-pointer transition-colors',
              'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand',
              selected
                ? 'border-brand bg-brand/5 text-brand'
                : 'border-input hover:bg-accent hover:text-accent-foreground',
            )}
          >
            <Icon className="h-4 w-4" />
            {label}
          </button>
        )
      })}
    </div>
  </div>
)
